export default __webpack_public_path__ + "static/media/cadastro.87dd284d.png";